import { forwardRef, useImperativeHandle } from 'react';
import { debug } from 'zf-web-infra';
import { useChartsOption } from './hooks/useChartsOption';
import { downloadChart } from './download';
import { useLoading, useInit } from './hooks';
import type { ChartsProps } from './types';
import type { ReactElement, Ref } from 'react';

export const Charts = forwardRef((props: ChartsProps, ref: Ref<unknown> | undefined): ReactElement => {
  debug.common('Charts', props.option);

  const styles = { width: '100%', height: '100%', ...props.style };
  const { node, getInstance } = useInit(props.theme, props.style);

  useLoading({ node, loading: props.loading, theme: props.theme });
  useChartsOption({
    node,
    option: props.option,
    settings: props.settings,
    theme: props.theme
  }, props.events);

  useImperativeHandle(ref, () => ({
    dom: node.current,
    getInstance
  }), [node.current]);

  return (
    <div id={props.id} className={props.className ?? ''} ref={node} style={styles} />
  );
});

export const charts = { download: downloadChart };
export type * from './types';
